import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/*
  /social/:network/:type/:id - e.g. tweet or timeline
  /legacy/listings/:uac/:ref
  /legacy/bidding/:listingRef
  /legacy/finance/application
  /legacy/finance/quickquote
  /legacy/haulage/quickquote
  /silo/animal/:id
  /silo/prices
  /silo/news
  /scrape/marts
  ?token & ?application
*/

const routes = [
  {
    path: '/legacy/bidding/:listingRef',
    name: 'Bidding',
    component: () => import(/* webpackChunkName: "bidding" */ '../views/Bidding.vue')
  },
  {
    path: '/legacy/listings/:uac?/:ref?',
    name: 'Listings',
    component: () => import(/* webpackChunkName: "listings" */ '../views/Listings.vue')
  },
  {
    path: '/legacy/haulage/instantquote',
    name: 'HaulageInstantQuote',
    component: () => import(/* webpackChunkName: "haulage-instantquote" */ '../views/HaulageInstantQuote.vue')
  },
  {
    path: '/legacy/haulage/quote/:id?',
    name: 'HaulageQuote',
    component: () => import(/* webpackChunkName: "haulage-quote" */ '../views/HaulageQuote.vue')
  },
  {
    path: '/legacy/haulage/load/:id',
    name: 'HaulageLoad',
    component: () => import(/* webpackChunkName: "haulage-load" */ '../views/HaulageLoad.vue')
  },
  {
    path: '/legacy/finance/instantquote',
    name: 'FinanceInstantQuote',
    component: () => import(/* webpackChunkName: "finance-instantquote" */ '../views/FinanceInstantQuote.vue')
  },
  {
    path: '/legacy/finance/application',
    name: 'FinanceApplication',
    component: () => import(/* webpackChunkName: "finance-application" */ '../views/FinanceApplication.vue')
  },
  {
    path: '/social/facebook/page/:id',
    name: 'SocialFacebookPage',
    component: () => import(/* webpackChunkName: "social-facebook-page" */ '../views/SocialFacebookPage.vue')
  },
  {
    path: '/legacy/silo/animal/:eartag',
    name: 'SiloAnimal',
    component: () => import(/* webpackChunkName: "silo-animal" */ '../views/SiloAnimal.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
